import React, { FC } from "react";
import { ClearAllContainer } from "@ldp-web/component-library/ui/molecules/clear-all-container";
import { Box } from "@ldp-web/component-library/ui/atoms/box";
import { TSDMFilterGroup, useFilterTracking } from "@ldp/sdm-analytics-utils";
import { handleFilterSelect, useRedirectLink } from "../../utils";
import {
  useRemoveAllQueryParams,
  useUpdateFilterQueryParams,
} from "../../hooks";
import { TSDMSelectedFiltersType } from "@ldp/common-types";
import { useSDMRouterContext } from "@ldp/sdm-contexts";

/** props for Filter Chip component */
export type IFilterChipComponentProps = {
  /** filter groups data */
  filterGroups: TSDMFilterGroup[];
  /** clear all label */
  clearAllLabel: string;
  /** remove filter label */
  removeFilterLabel: string;
};
/** Displayed Filter chips with clear all for selected filters */
export const FilterChipComponent: FC<IFilterChipComponentProps> = ({
  filterGroups,
  clearAllLabel,
  removeFilterLabel,
}) => {
  /**
   * variable get selected fitlers to show filter chips
   * updates filter chips data based on the api response
   */
  const filterChipData = filterGroups
    .map((filterGroups) => {
      const parentCode = filterGroups.code;
      return filterGroups.values
        .filter((filter) => filter.selected)
        .map((filter) => ({ ...filter, parentCode }));
    })
    .flat();
  /** flag to show or hide fitler chip component */
  const showFilterChip = filterChipData.length > 0;
  const router = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);
  const removeAllQueryParams = useRemoveAllQueryParams();
  const updateFilterQueryParams = useUpdateFilterQueryParams();
  const trackFilterFn = useFilterTracking();

  const handleRemoveFilter = (filterType: TSDMSelectedFiltersType) => {
    handleFilterSelect(
      filterType,
      filterGroups,
      updateFilterQueryParams,
      trackFilterFn,
      redirectToPage
    );
  };

  const handleClearAll = () => {
    const updatedUrl = removeAllQueryParams();
    redirectToPage(updatedUrl);
  };

  return (
    <>
      {showFilterChip && (
        <Box m={0} p={0}>
          <ClearAllContainer
            clearAllLabel={clearAllLabel}
            filters={filterChipData as any}
            handleClearAll={handleClearAll}
            handleRemoveFilter={handleRemoveFilter}
            removeFilterLabel={removeFilterLabel}
          />
        </Box>
      )}
    </>
  );
};

export default FilterChipComponent;
